import { render, staticRenderFns } from "./InvoiceBack.vue?vue&type=template&id=f4092ddc&scoped=true&"
import script from "./InvoiceBack.vue?vue&type=script&lang=js&"
export * from "./InvoiceBack.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceBack.vue?vue&type=style&index=0&id=f4092ddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4092ddc",
  null
  
)

export default component.exports